<script>
  import DropdownModal from '@/_legacy/views/ConductInspection/Modals/DropdownModal.vue';
  import { ENTITY_ITEMS_DROPDOWN_LIMIT } from '@/_legacy/constants';

  export default {
    components: { DropdownModal },
    props: {
      entityItem: {
        type: [String, Number],
        required: false,
        default: null,
      },
      entityItems: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      isDropdownVisible: false,
      limit: ENTITY_ITEMS_DROPDOWN_LIMIT,
    }),
    computed: {
      normalizedEntityItems() {
        return Object.entries(this.entityItems)
          .map(([uuid, title]) => ({
            uuid: Number.parseInt(uuid, 10),
            title,
          }))
          .sort(
            (a, b) => a.title.localeCompare(b.title)
          );
      },
      dropdownText() {
        return this.entityItem
          ? this.entityItems[this.entityItem]
          : this.$t('Select from dropdown');
      },
    },
    mounted() {
      if (this.normalizedEntityItems.length === 1) {
        this.entityItemSelected([this.normalizedEntityItems[0].uuid]);
      }
    },
    methods: {
      entityItemSelected([entityItemId]) {
        this.$emit('entityItemSelected', entityItemId);
        this.closeDropdown();
      },
      showDropdown() {
        this.isDropdownVisible = true;
      },
      closeDropdown() {
        this.isDropdownVisible = false;
      },
    },
  };
</script>

<template>
  <div class="preview__question">
    <h2>
      {{ $t('Select entity item') }}
    </h2>

    <div
      class="w-full form-select mb-3"
      :class="{ empty: !entityItem }"
      @click="showDropdown"
    >
      <span>
          {{ dropdownText }}
      </span>
    </div>

    <portal to="modals">
      <transition name="fade">
        <DropdownModal
          v-if="isDropdownVisible"
          :responses="normalizedEntityItems"
          :response="entityItem ? [entityItem] : []"
          :limit="limit"
          :multiple="false"
          @save="entityItemSelected"
          @close="closeDropdown"
        />
      </transition>
    </portal>
  </div>
</template>
